import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SessionService } from './session.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { IEmpresaEnUnDia } from 'src/app/models/empresa-en-un-dia/empresa-en-un-dia.model';
import { IEmpresaEnUnDiaActuaciones, IListActuaciones, IReporteActuacion } from 'src/app/models/empresa-en-un-dia/empresa-en-un-dia-actuacion.model';
import { IUserInfoCognito } from './cognito.service';

@Injectable({
    providedIn: 'root'
})
export class EmpresaEnUnDiaService {
    private endpoint: string = environment.backend.empresaEnUnDia.url;
    private readonly REQUEST_ORIGIN = 'WEB';

    constructor(
        private _sessionService: SessionService,
        private http: HttpClient
    ) { }

    private getHeaders(idOrganizacion: string, idUsuario: string, requestOrigin: string): HttpHeaders {
        const headers = new HttpHeaders()
            .set("IDOrganizacion", idOrganizacion)
            .set("IDUsuario", idUsuario)
            .set("requestOrigin", requestOrigin)

        return headers;
    }

    buildHttpParams(paramsObj?: Record<string, string | number | null | undefined>): HttpParams {
        let params = new HttpParams();

        if (!paramsObj) return params;

        for (const [key, value] of Object.entries(paramsObj)) {
            if (value != null && value !== '') {
                params = params.set(key, value);
            }
        }

        return params;
    }

    public createReport(rut: string): Observable<IEmpresaEnUnDia> {

        const userInfo: IUserInfoCognito = this._sessionService.getUserInfo();
        const idUsuario = userInfo.email;
        const idOrganizacion = this._sessionService.getOrganization();

        const headers = this.getHeaders(idOrganizacion, idUsuario, this.REQUEST_ORIGIN);
        const payload = { rut };

        return this.http.post<IEmpresaEnUnDia>(`${this.endpoint}crearReporte`, payload, { headers });
    }

    public listReports(rut: string, type = ''): Observable<IEmpresaEnUnDia[]>  {

        const userInfo: IUserInfoCognito = this._sessionService.getUserInfo();
        const idUsuario = userInfo.email;
        const idOrganizacion = this._sessionService.getOrganization();

        const headers = this.getHeaders(idOrganizacion, idUsuario, this.REQUEST_ORIGIN);
        const params = this.buildHttpParams({ rut, type });

        return this.http.get<IEmpresaEnUnDia[]>(`${this.endpoint}buscarReportes`, { headers, params });
    }

    public searchTX(id_transaccion: string): Observable<IEmpresaEnUnDia> {

        const userInfo: IUserInfoCognito = this._sessionService.getUserInfo();
        const idUsuario = userInfo.email;
        const idOrganizacion = this._sessionService.getOrganization();

        const headers = this.getHeaders(idOrganizacion, idUsuario, this.REQUEST_ORIGIN);
        const params = this.buildHttpParams({ id_transaccion });

       return this.http.get<IEmpresaEnUnDia>(`${this.endpoint}buscarTX`, { headers, params });
    }

    public getLastReport(rut: string, type: string): Observable<IEmpresaEnUnDia> {

        const userInfo: IUserInfoCognito = this._sessionService.getUserInfo();
        const idUsuario = userInfo.email;
        const idOrganizacion = this._sessionService.getOrganization();

        const headers = this.getHeaders(idOrganizacion, idUsuario, this.REQUEST_ORIGIN);
        const params = this.buildHttpParams({ rut, type });

        return this.http.get<IEmpresaEnUnDia>(`${this.endpoint}buscarUltimo`, { headers, params });
    }

    public listarActuaciones(rut = '', fechaDesde = '', fechaHasta = '', pagina?: number, porPagina?: number): Observable<IListActuaciones>  {
        const userInfo: IUserInfoCognito = this._sessionService.getUserInfo();
        const idUsuario = userInfo.email;
        const idOrganizacion = this._sessionService.getOrganization();

        const headers = this.getHeaders(idOrganizacion, idUsuario, this.REQUEST_ORIGIN);
        const params = this.buildHttpParams({ rut, pagina,  porPagina, fechaDesde, fechaHasta });

        return this.http.get<IListActuaciones>(`${this.endpoint}actuaciones`, { headers, params });
    }

    public buscarActuacion(numeroAtencion: string): Observable<IReporteActuacion>  {
        const userInfo: IUserInfoCognito = this._sessionService.getUserInfo();
        const idUsuario = userInfo.email;
        const idOrganizacion = this._sessionService.getOrganization();

        const headers = this.getHeaders(idOrganizacion, idUsuario, this.REQUEST_ORIGIN);
        const params = this.buildHttpParams({ numeroAtencion });

        return this.http.get<IReporteActuacion>(`${this.endpoint}actuacion`, { headers, params });
    }

    public createReportActuaciones(rut: string): Observable<IEmpresaEnUnDia> {

        const userInfo: IUserInfoCognito = this._sessionService.getUserInfo();
        const idUsuario = userInfo.email;
        const idOrganizacion = this._sessionService.getOrganization();

        const headers = this.getHeaders(idOrganizacion, idUsuario, this.REQUEST_ORIGIN);
        const payload = { rut };

        return this.http.post<IEmpresaEnUnDia>(`${this.endpoint}actuacion`, payload, { headers });
    }
}
